<template>
  <div class>
    <div
      slot="header"
      class="clearfix"
      style="background-color: #f2f2f2; padding: 20px"
    >
      <span style="font-weight: 600; color: #000; line-height: 10px"
        >设备信息</span
      >
    </div>
    <div class style="margin-top: 30px">
      <SForm
        ref="deviceForm"
        :url="deviceUrl"
        method="put"
        :fields="deviceFields"
        :dataForm="deviceFormdata"
        labelWidth="180px"
        :inline="false"
        :before="formbefore"
        :handle="formhandle"
        formStyle="width: 500px;"
      >
      </SForm>
    </div>
  </div>
</template>

<script>
import request from "@/utils/request.js";

//import x from ''
export default {
  name: "tongzhiguanli",
  components: {},
  data() {
    return {
      deviceUrl: "/battery/dcDevice/put",
      deviceFormdata: {},
      brandData: [],
      deviceFields: [
        {
          label: "SN",
          type: "",
          prop: "SN",
          placeholder: "请输入SN",
          rules: [
            {
              required: true,
              message: "请输入SN",
              trigger: "blur"
            }
          ]
        },
        {
          label: "设备名称",
          type: "",
          prop: "name",
          placeholder: "请输入设备名称",
          rules: [
            {
              required: true,
              message: "请输入设备名称",
              trigger: "blur"
            }
          ]
        },
        {
          label: "品牌型号",
          type: "cascadersingle",
          prop: "brandID",
          options: this.brandData,
          ref: "brandModeRef",
          // props: { value: "id", label: "name" },
          placeholder: "请选择品牌型号",
          rules: [
            {
              required: true,
              message: "请选择品牌型号",
              trigger: "change"
            }
          ]
        },
        {
          label: "簇数",
          type: "number",
          prop: "clusterCount",
          placeholder: "请输入簇数",
          rules: [
            {
              required: true,
              message: "请输入簇数",
              trigger: "blur"
            },
            {
              pattern: /^[0-9]\d*$/,
              message: "请输入正整数"
            }
          ]
        },
        {
          label: "选择协议",
          type: "select",
          prop: "protocolID",
          placeholder: "请选择协议",
          defaultValue: "",
          data: this.$route.query.protocol,
          rules: [
            {
              required: true,
              message: "请选择协议",
              trigger: "change"
            }
          ]
        },
        {
          label: "行业应用",
          type: "select",
          prop: "industryApplication",
          placeholder: "请选择行业应用",
          defaultValue: "单轨电车",
          data: [
            {
              label: "单轨电车",
              value: "单轨电车"
            },
            {
              label: "轨道交通",
              value: "轨道交通"
            },
            {
              label: "叉车",
              value: "叉车"
            },
            {
              label: "机场储能",
              value: "机场储能"
            },
            {
              label: "AGV智能车量",
              value: "AGV智能车量"
            },
            {
              label: "工程机械",
              value: "工程机械"
            },
            {
              label: "AGV电源",
              value: "AGV电源"
            },
            {
              label: "工商储能",
              value: "工商储能"
            },
            {
              label: "家庭储能",
              value: "家庭储能"
            },
            {
              label: "汽车电源",
              value: "汽车电源"
            },
            {
              label: "叉车电源",
              value: "叉车电源"
            },
            {
              label: "两轮车电源",
              value: "两轮车电源"
            },
            {
              label: "其它特殊电源",
              value: "其它特殊电源"
            }
          ],
          rules: [
            {
              required: true,
              message: "请选择行业应用",
              trigger: "blur"
            }
          ]
        },
        {
          label: "Pack编码",
          type: "",
          prop: "dcPackCode",
          placeholder: "请输入Pack编码",
          rules: [
            {
              required: false,
              message: "请输入Pack编码",
              trigger: "blur"
            }
          ]
        },
        {
          label: "电池模组编码",
          type: "",
          prop: "dcModuleCode",
          placeholder: "请输入电池模组编码",
          rules: [
            {
              required: false,
              message: "请输入电池模组编码",
              trigger: "blur"
            }
          ]
        },
        {
          label: "生产时间",
          prop: "dcProductionDate",
          placeholder: "请选择生产时间",
          type: "date",
          option: {
            type: "datetime"
          }
        },
        {
          label: "出货时间",
          prop: "dcDeliveryDate",
          placeholder: "请选择出货时间",
          type: "date",
          option: {
            type: "datetime"
          }
        }
      ],
      formbefore: record => {
        console.log(record);
        let data = {
          SN: record.SN,
          name: record.name,
          brandID: record.brandID[0],
          modelID: record.brandID[1],
          protocolID: record.protocolID,
          clusterCount: record.clusterCount,
          projectID: this.$route.query.projectId,
          industryApplication: record.industryApplication,
          dcPackCode: record.dcPackCode,
          dcModuleCode: record.dcModuleCode,
          dcProductionDate: record.dcProductionDate,
          dcDeliveryDate: record.dcDeliveryDate
        };

        return data;
      },
      formhandle: record => {
        this.$router.go(-1);
      }
    };
  },
  computed: {},
  methods: {},
  mounted() {},
  created() {},
  beforeCreate() {
    this.brandData = this.$route.query.brandData;
  }, //生命周期 - 创建之前
  beforeMount() {
    this.deviceFormdata = this.$route.query.data;

    let protocolName = this.deviceFormdata.protocolName;
    for (let i = 0; i < this.$route.query.protocol.length; i++) {
      if (this.$route.query.protocol[i].label == protocolName) {
        this.deviceFormdata.protocolID = this.$route.query.protocol[i].value;
        console.log(this.deviceFormdata.protocolID);
        break;
      }
    }
  }, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {} //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>

<style lang="less" src="" scoped>
.btn {
  width: 600px;
  height: 50px;
  margin-top: 10px;
  margin-left: 40%;
}
.resetbtn:hover {
  border: 1px solid #00cc00;
  color: #00cc00;
}
.resetbtn:active {
  border: 1px solid #00cc00;
  color: #ffffff;
  background-color: #00cc00;
}
</style>



// WEBPACK FOOTER //
// src/views/BMS/deviceManagement/modifyDevice.vue